import { Splide } from '@splidejs/react-splide'
import { sponsorsBannersOptions } from '../../../config/splide-slide-options'

export default function SilderSponsersBanners({ children }) {
  return (
    <div
      data-aos="fade-up"
      className={`app-container px-8 lg:px-0`}
    >
      <Splide options={sponsorsBannersOptions}>{children}</Splide>
    </div>
  )
}
